import { CloseIcon } from "../../assets/Icons/icons";

const Modal = ({ isOpen, onClose, title, children, footer, size = "md", showCloseButton = true, className = "" }) => {
  if (!isOpen) return null;

  const sizes = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-2xl",
  };

  const sizeClass = sizes[size] || sizes.md;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div
        className={`bg-white rounded-lg w-full ${sizeClass} shadow-xl border border-gray-200 flex flex-col max-h-[90vh] overflow-hidden ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        {title && (
          <div className="px-6 py-4 border-b border-gray-200 flex-shrink-0">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-semibold text-secondary">{title}</h2>
              {showCloseButton && (
                <button
                  onClick={onClose}
                  className="text-gray-400 hover:text-gray-500 transition-colors focus:outline-none"
                  aria-label="Close modal"
                >
                  <CloseIcon className="w-5 h-5" />
                </button>
              )}
            </div>
          </div>
        )}

        {/* Modal Body */}
        <div className="px-6 py-5 overflow-y-auto flex-1 custom-scrollbar">{children}</div>

        {/* Modal Footer */}
        {footer && <div className="px-6 py-4 border-t border-gray-200 flex-shrink-0">{footer}</div>}
      </div>
    </div>
  );
};

export default Modal;
